import React from "react"
import "twin.macro"

const Section = ({ children, ...props }) => {
  return (
    <section tw="py-12 text-white" {...props}>
      {children}
    </section>
  )
}

export default Section
